import { Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SectionsService } from '../../../../services/sections.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Router } from '@angular/router';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { AccordionComponent } from "../../../../shared/components/accordion/accordion.component";
import { AuthUtilizationComponent } from "../auth-utilization/auth-utilization.component";
import { AuthTimesheetsComponent } from "../auth-timesheets/auth-timesheets.component";
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { GridAction } from '../../../../shared/components/list-table/grid-action.model';
import { AuthFormsComponent } from "../auth-forms/auth-forms.component";
import { AuthorizationsDetailsService } from '../../../../services/authorizations-service.service';
import { ListService } from '../../../../shared/services/list.service';
import { AuthorizationDocumentsComponent } from '../authorization-documents/authorization-documents.component';
import { ClaimsService } from '../../../../services/claims.service';
import { AuthAdditionalDetailsComponent } from '../auth-additional-details/auth-additional-details.component';
import { NotificationService } from '../../../../shared/services/notification.service';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { UserService } from '../../../../services/user.service';
@Component({
  selector: 'ppl-authorization-details',
  standalone: true,
  imports: [ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    NzCollapseModule,
    AccordionComponent,
    AuthUtilizationComponent,
    AuthTimesheetsComponent,
    ListTableComponent, 
    AuthFormsComponent,
  AuthorizationDocumentsComponent,
AuthAdditionalDetailsComponent],
  templateUrl: './authorization-details.component.html',
  styleUrl: './authorization-details.component.css'
})
export class AuthorizationDetailsComponent extends BaseComponent implements OnInit  {
  authorizationsForm!: FormGroup;
  radioOptions = RADIO_YES_NO_OPTIONS;
  providerTypes: any;
  pageTitle = 'Add Authorization';
  mode = 'read';
  savedData: any = {};
  isNew = true;
  isParticipantSelected = false;
  isConsumerSelected = false;
  showConsumersList = false;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any;
  lazyLoad = true;
  cols: any[] = [];
  flow: string|null = '';
  selectedConsumer: any;
  selectedAuthId: any;
  diagnosisCodesList: any;
  filledDiagnosisValue = '';
  disableForm = true;
  actionButtons: TableRowActionsModel = new TableRowActions({ add: true });
  authData: any;
  showDeleteBtn = true;
  private dialogSvc = inject(DialogService);
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('authDialog') authDialog!: TemplateRef<any>;
  @ViewChild('authHistoryDialog') authHistoryDialog!: TemplateRef<any>;
  @Input() pageSource: any;

  auth_cols: any = [
    {
      "field": "authDetailId",
      "header": "Authorization ID",
      "jsonpath": "authDetailId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "startDate",
      "header": "Start Date",
      "jsonpath": "startDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "endDate",
      "header": "End Date",
      "jsonpath": "endDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "units",
      "header": "Units",
      "jsonpath": "units",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "usedUnits",
      "header": "Used Units",
      "jsonpath": "usedUnits",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    }
  ]

  auth_history_cols: any = [
    {
      "field": "fileName",
      "header": "File Name",
      "jsonpath": "fileName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "payerId",
      "header": "Payer Id",
      "jsonpath": "payerId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "authorizationId",
      "header": "Auth Id",
      "jsonpath": "authorizationId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "authorizationNumber",
      "header": "Auth Number",
      "jsonpath": "authorizationNumber",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "billingServiceCode",
      "header": "Service Code",
      "jsonpath": "billingServiceCode",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "fromDate",
      "header": "From Date",
      "jsonpath": "fromDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "toDate",
      "header": "To Date",
      "jsonpath": "toDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "authorizationType",
      "header": "Auth Type",
      "jsonpath": "authorizationType",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "hoursPerWeek",
      "header": "Hours Per Week",
      "jsonpath": "hoursPerWeek",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "hoursPerMonth",
      "header": "Hours Per Month",
      "jsonpath": "hoursPerMonth",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "hoursPerAuthPeriod",
      "header": "Hours Per Auth Period",
      "jsonpath": "hoursPerAuthPeriod",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "sunHours",
      "header": "Sun Hours",
      "jsonpath": "sunHours",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "monHours",
      "header": "Mon Hours",
      "jsonpath": "monHours",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "tueHours",
      "header": "Tues Hours",
      "jsonpath": "tueHours",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "wedHours",
      "header": "Wed Hours",
      "jsonpath": "wedHours",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "thuHours",
      "header": "Thurs Hours",
      "jsonpath": "thuHours",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "friHours",
      "header": "Fri Hours",
      "jsonpath": "friHours",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "satHours",
      "header": "Sat Hours",
      "jsonpath": "satHours",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "isDeletion",
      "header": "Is Deletion",
      "jsonpath": "isDeletion",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "userField1",
      "header": "Diagnosis Code",
      "jsonpath": "userField1",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "userField5",
      "header": "CIN",
      "jsonpath": "userField5",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "ingestionStatus",
      "header": "Ingestion Status",
      "jsonpath": "ingestionStatus",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    }
  ]
  
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private listService: ListService,
    private authorizationService: AuthorizationsDetailsService,
    private notificationService: NotificationService,
    private claimsService: ClaimsService,
    private userService: UserService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.authorizationsForm = this.fb.group({
        firstName: [[]],
        lastName: [[]],
        medicaid: [[]],
        pplId: [[]],
        plAuthNumber: [[]],
        clientAuthNumber: [[]],
        hcpcsServiceCode: [[]],
        modifier1: [null],
        modifier2: [null],
        modifier3: [null],
        modifier4: [null],
        units: [[]],
        dollars: [[]],
        authStartDate: [[]],
        authEndDate: [[]],
        mcoId: [[]],
    });

    const program = this.userService.getSelectedProgram();
    this.flow = this.sectionsService.getFlow() ?? '';
    this.selectedAuthId = this.userService.getSelectedLead();
    this.programName = program?.program_code ?? '';
    this.secData = this.sectionsService.getSectionData(
      program?.program_code,
      'payroll'
    );
    this.providerTypes = this.getLookup('ProviderType');
    // this.lookupService.getDiagnosisLookupValues().subscribe((data: any) => {
    //   console.log('data', data.responsedata);
    //   this.diagnosisCodesList = data.responsedata;
    // });
    // this.diagnosisCodesList = this.lookupService.getTasLookupValue(
    //   'diagnosisDetailList'
    // );

    this.claimsService.authUpdated.subscribe((val)=>{
      if(val) {
        this.getAuthDetails();
      }
    })
    this.getGridHeaders();
    this.getAuthDetails();

  }

  returnClicked() {
    console.log('going back from process codes');
    this.router.navigate(['/home/authorizationsList']);
  }
  
  goBack() {
    this.router.navigate(['/home/authorizationsList']);
  }

  onEdit() {
    this.mode = 'edit';
    this.disableForm = false;
    //patch form here;
  }

  splitAuthData: any;
  authHistoryData: any;

  onViewSplit(){
    // this.claimsService.setPopUpState('authSplit');
    this.claimsService.getAuthSpiltData(this.programName, this.authData.authorizationId).subscribe((data: any)=>{
      if(data.status == 200){
        this.splitAuthData = data.responsedata;
        // if(this.splitAuthData){
          const dialogConfig: DialogConfig = {
            title: 'Split Authorization Data',
            isOkText: 'Ok',
            size: 'large',
            position: 'top',
            showClose: true,
            showButtons: false,
            styleClass: 'split-auth-data'
          };
      
          this.dialogSvc.openDialog(
            this.authDialog,
            dialogConfig,
            () => this.handleCancel(),
            () => this.handleCancel()
          );
        // }
      }
    })
  }

  onViewAuthHistory(){
    this.claimsService.getAuthHistoryData(this.programName, this.authData.payerId, this.authData.hhaAuthId, ).subscribe((data: any)=>{
      if(data.status == 200){
        this.authHistoryData = data.responsedata;
          const dialogConfig: DialogConfig = {
            title: 'Auth History Data',
            isOkText: 'Ok',
            size: 'x-large',
            position: 'top',
            showClose: true,
            showButtons: false,
            styleClass: 'split-auth-data'
          };
      
          this.dialogSvc.openDialog(
            this.authHistoryDialog,
            dialogConfig,
            () => this.handleCancel(),
            () => this.handleCancel()
          );
      }
    })
  }

  onConsumerSearch() {
    this.showConsumersList = true;
  }

  async getGridHeaders() {
    try {
        if(this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(STATIC_JSON_DATA_PATH.AUTHORIZATIONS_CONSUMER_LIST_HEADERS, this.flow);
        console.log(tempCols.columns);
        this.cols = tempCols.columns;
        }
    } catch (e) {
    }

  }

  getAuthDetails() {
    // this.authorizationService.getAuthorizationDetails(this.programName, this.selectedAuthId).subscribe((data: any) => {
    //   console.log('details', data);
    // })

    const payload = this.buildRequestPayload();
    const from = '';
      this.listService.getListData(payload, from).subscribe((data: any) => {
        console.log('search data', data);
        this.authData = data.responsedata[0];
        // this.filledDiagnosisValue = this.diagnosisCodesList?.find((diagnosis:any) => diagnosis?.diagnosisDetailId === this.authData?.diagnosisId)?.description;

        //this.gridData = data.responsedata;
      });

  }

  buildRequestPayload(event?: any) {
    const formData = this.authorizationsForm.value;
    const payload: any = {
      pageName: 'consumer-auth',
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: [{
        jsonPath: 'authorizationId',
        value: this.selectedAuthId,
        operator: 'equal'
      }],
      orderByColumn: [],
      orderBy: [],
    }

    return payload;
  }

  action(event: GridAction) {
    if (event && event.action === 'add') {
        console.log(event.data);
        this.selectedConsumer = event.data;
        this.isConsumerSelected = true;
        this.showConsumersList = false;
    }

  }

  onAuthUpdate(event: any) {
    console.log('update event!', event);
    this.mode = 'read';
    this.disableForm = true;
    if(event) {
      this.getAuthDetails();
    }
  }

  onDeleteAuth() {
    console.log('delete clicked');
    this.openConfirmationPopup();
  }

  openConfirmationPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteAuth(),
      () => this.handleCancel()
    );
  }

  handleCancel() { }

  deleteAuth() {
    this.authorizationService.deleteAuthorization(this.programName, this.selectedAuthId).subscribe((data: any) => {
      console.log('deleted');
      this.showDeleteBtn = false;
      this.getAuthDetails();
      this.notificationService.alert(
        'success',
        'Success',
        `Authorization deactivated successfully`
      );
    });
  }

  onAdd() {
    console.log('Adding!!');
  }

  onCancel() {
    this.mode = 'read';
    this.disableForm = true;
    this.validationErrors = {};
    this.authorizationsForm.reset();
  }

  onUpdate() {
    console.log('Updating!!');
    this.mode = 'read';
    this.disableForm = true;
    this.validationErrors = {};
    this.authorizationsForm.reset();
  }

  viewerValueChange(value: string) {
    const viewerValue = [value][0];
    this.isParticipantSelected = true;
  }
}
